import React, { useEffect, useState } from "react";
import PettyCashCard from "./PettyCashCard";
import ApiManager from "../../ApiManager/ApiManager";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import NewPettyCash from "../NewPettyCash";

const PettyCashDrawerTable = ({ row, from, to, drawerWidth }) => {
  const [pettyCashList, setPettyCashList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPettyCash = async () => {
    setLoading(true);
    try {
      const queryObj = {
        driverId: row.driver_id,
        page_size: 1000,
        page: 1,
      };
      if (from) queryObj.from = from;
      if (to) queryObj.to = to;
      const query = new URLSearchParams(queryObj);
      const response = await ApiManager.getAllPettyCash(query);
      if (!response.ok) throw new Error("Failed to fetch petty cash");
      const data = await response.json();
      setPettyCashList(data || []);
    } catch (error) {
      setPettyCashList([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPettyCash();
    // eslint-disable-next-line
  }, [row.driver_id, from, to]);

  if (loading) return <LoadingSpinner message="Loading petty cash data..." />;
  if (!pettyCashList.length) return (
    <div style={{ padding: 24 }}>
      {/* <div style={{ marginBottom: 16 }}>
        <NewPettyCash onSuccess={fetchPettyCash} />
      </div> */}
      No petty cash records found.
    </div>
  );

  return (
    <div style={{ padding: 8 }}>
      <div style={{ margin: 16, display: "flex", justifyContent: "flex-end" }}>
        <NewPettyCash onSuccess={fetchPettyCash} />
      </div>
      {pettyCashList.map((item, idx) => (
        <PettyCashCard key={item.id || idx} pettyCash={item} />
      ))}
    </div>
  );
};

export default PettyCashDrawerTable; 